import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { NewOrdersTitle } from '../../../../Utils/Constants'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import SvgIcon from '../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { H2, P } from '../../../../AbstractElements'
import ReactApexChart from 'react-apexcharts'
import { admissionRatioOption } from '../../../../Data/DashboardsData/DefaultData'

export default function DailyRevenueCard() {
    return (
        <Col xl={3} lg={3} md={4} sm={6} className="box-col-3">
            <Card>
                <DropdownWithHeader headerClass='card-no-border pb-0' topDivClass='daily-revenue-card' heading={NewOrdersTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="pb-0 total-sells">
                    <div className="d-flex align-items-center gap-3">
                        <div className="flex-shrink-0 bg-light-primary">
                            <SvgIcon iconId='order-product' />
                        </div>
                        <div className="flex-grow-1">
                            <div className="d-flex align-items-center gap-2">
                                <H2>{'12,463'}</H2>
                                <div className="d-flex total-icon">
                                    <P className="mb-0 up-arrow bg-light-success">
                                        <i className="fa fa-arrow-up text-success" />
                                    </P>
                                    <span className="f-w-500 font-success">{'+ 5.8% '}</span>
                                </div>
                            </div>
                            <P className="text-truncate">{'In contrast to Jan 2024'}</P>
                        </div>
                    </div>
                    <div id="admissionRatio">
                        <ReactApexChart type='area' options={admissionRatioOption} series={admissionRatioOption.series} height={115} />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}